'use client';

import { useEffect, useState } from 'react';

// Custom hook to get window dimensions
const useWindowDimensions = () => {
  // State to store window width and height
  const [windowDimensions, setWindowDimensions] = useState({
    width: globalThis?.window?.innerWidth,
    height: globalThis?.window?.innerHeight,
  });

  useEffect(() => {
    // Handler to update state with new window dimensions
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};

export default useWindowDimensions;
